<template>
  <el-dialog
    :visible="showInvite"
    :show-close="false"
    custom-class="InviteDialog"
    width="90vw"
  >
    <section class="InviteContent">
      <i @click="closeInvite" class="el-icon-circle-close"></i>
      <div class="activity">
        <div class="activityItem">
          <div class="activityType">企业<span>(须认证)</span></div>
          <div class="activityInfo">100点<br />5件版权登记</div>
        </div>
        <div class="activityItem">
          <div class="activityType">设计师</div>
          <div class="activityInfo">100点</div>
        </div>
        <div class="activityItem">
          <div class="activityType">好友返现</div>
          <div class="activityInfo">首单10%金额<br />返现您账户</div>
        </div>
      </div>
      <div class="activityDesc">
        说明：1.邀请企业用户注册并完成企业认证，双方立即获得100点+5件版权
        <br />
        2.邀请设计师用户注册并完成设计师入驻，双方立即获得100点
        <br />
        3.好友如产生会员消费，首单10%金额返现您账户。<span
          @click="showDesc = true"
          >查看详细规则 <i class="el-icon-arrow-right"></i>
        </span>
      </div>
      <div class="inviteBtn">
        <div @click="drawPoster" class="btn">海报邀请</div>
        <div class="btn copyBtn" :data-clipboard-text="shareUrl">链接邀请</div>
      </div>
      <!-- 海报弹框 -->
      <el-dialog
        :visible.sync="showPoster"
        :show-close="false"
        width="450px"
        top="8vh"
        custom-class="PosterDialog"
        append-to-body
      >
        <section class="PosterContent">
          <div class="poster">
            <PosterFrawing
              ref="poster"
              :imgUrl="posterImg"
              :url="shareUrl"
              :show="showPoster"
              :ratio="0.275"
              :leftRatio="0.638"
              :topRatio="0.851"
            />
          </div>
          <div class="closeBtn">
            <i @click="showPoster = false" class="el-icon-circle-close"></i>
          </div>
          <div @click="downPoster" class="downBtn">下载您的专属海报</div>
        </section>
      </el-dialog>
      <el-dialog
        title="活动规则"
        :visible.sync="showDesc"
        custom-class="DescDialog"
        append-to-body
      >
        <section>
          <p>
            1.邀请奖励：邀请好友注册领取成功，系统给好友自动发放100点（约50张AI生成设计）。领取后，若好友完成企业认证后，好友和邀请人可各自再免费获得100点+5件版权；若好友完成设计师入驻后，好友和邀请人可各自再免费获得100点。
          </p>
          <p>
            2.返现奖励：活动期间，邀请好友领取免费点数与版权登记，好友如产生会员类消费，邀请者可获首单10%金额返现至账户。企业用户返现站内消费，个人用户可提现。最终解释权归平台所有。
          </p>
          <p>
            3.奖励有效期：获得的奖励具有有效期，用户需在规定的时间内使用，逾期未使用将自动失效。
          </p>
          <p>
            4.活动时间：活动时间为指定时间段内有效，用户需在活动期间内完成邀请注册操作才能获得奖励。
          </p>
          <p>
            5.违规处理：如发现用户通过欺诈、刷量等违规手段获取奖励，系统有权取消用户的奖励资格并追究相应责任。
          </p>
          <p>
            6.活动变更：客户有权根据实际情况调整活动规则或终止活动，并将提前通知用户。
          </p>
        </section>
      </el-dialog>
    </section>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import ClipboardJS from "clipboard";
import PosterFrawing from "./PosterFrawing.vue";
import {
  getMyEventCode,
  GetSaleId,
  getCurrentUserInfo,
} from "../service/commonApi";
import { getUserInfo } from "../service/GenerateAI/index";
export default {
  components: { PosterFrawing },
  data() {
    return {
      showPoster: false, // 显示海报弹框
      posterImg: "https://static.iyw.cn/portal/H5/inviteAi/poster2.jpg", // 邀请背景图
      currentUserInfo: {}, // 当前用户信息
      userInfo: {}, // 用户信息
      shareInfo: {},
      employeeNumber: "", // 员工编号
      showDesc: false, // 显示活动规则
    };
  },
  computed: {
    ...mapGetters(["showInvite"]),
    shareUrl() {
      let share_puid = "";
      if (this.currentUserInfo?.crmId) {
        share_puid = this.currentUserInfo.crmId;
      } else if (this.userInfo?.orgInfo?.isInnerAccount) {
        share_puid = this.employeeNumber;
      } else {
        share_puid = "Q" + this.userInfo.orgInfo?.caihongNO;
      }
      return (
        process.env.VUE_APP_H5_DOMAIN +
        `/get/aiTenfold?share_puid=${share_puid}&channelCode=${this.shareInfo.eventCode}&from=${this.shareInfo.from}`
      );
    },
  },
  watch: {
    showInvite(val) {
      if (val) {
        this.getCurrentUserInfo();
        this.getShareUrl();
        this.getUserInfo();
      }
    },
  },
  mounted() {
    this.copyCode();
  },
  methods: {
    // 获取当前用户信息
    async getCurrentUserInfo() {
      const res = await getCurrentUserInfo();
      if (res.code == 1) {
        this.currentUserInfo = res.data;
      }
    },
    // 获取销售ID
    async getSaleId() {
      const res = await GetSaleId();
      if (res.code == 1) {
        this.employeeNumber = res.data;
      }
    },
    // 获取用户信息
    async getUserInfo() {
      const res = await getUserInfo();
      if (res.code == 1) {
        this.userInfo = res.data;
        if (this.userInfo.orgInfo.isInnerAccount) {
          this.getSaleId();
        }
      }
    },
    // 获取分享活动码
    async getShareUrl() {
      const res = await getMyEventCode();
      if (res.code == 1) {
        this.shareInfo = res.data;
      }
    },
    // 添加一键复制功能
    copyCode() {
      const clipboard = new ClipboardJS(".copyBtn");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        if (!e.text) this.$message.info("暂无可复制内容");
        e.clearSelection();
      });
    },
    // 生成海报
    drawPoster() {
      this.showPoster = true;
    },
    // 关闭邀请弹框
    closeInvite() {
      this.$store.commit("SET_SHOW_INVITE", false);
    },
    // 下载海报
    downPoster() {
      this.$refs.poster.downImg();
    },
  },
};
</script>
<style lang="scss">
.InviteDialog,
.PosterDialog {
  .el-dialog__header,
  .el-dialog__body {
    padding: 0 !important;
  }
}

.InviteDialog {
  background-image: url(https://static.iyw.cn/GenerateAI/invite/inviteBg1.png) !important;
  background-size: 100% 100% !important;
  background-color: transparent !important;
  box-shadow: none !important;
  max-width: 600px !important;

  .InviteContent {
    padding: 190px 44px 24px;
    position: relative;

    & > i {
      top: -35px;
      right: 0px;
      position: absolute;
      font-size: 28px;
      color: #fff;
      cursor: pointer;
    }

    .activity {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .activityItem {
        width: 155px;
        height: 160px;
        background-image: url(https://static.iyw.cn/GenerateAI/invite/redPacket.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        text-align: center;

        .activityType {
          font-weight: 600;
          font-size: 15px;
          color: #cd5c31;
          padding-top: 13px;

          & > span {
            font-size: 13px;
            font-weight: 400;
          }
        }

        .activityInfo {
          font-size: 18px;
          color: #fb4201;
          font-weight: 600;
          margin-top: 16px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .activityDesc {
      font-size: 14px;
      color: #999;
      text-indent: -3em;
      margin-top: 19px;
      padding-left: 3em;

      span {
        text-indent: 0;
        color: #2e2e2e;
        cursor: pointer;
      }
    }

    .inviteBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 21px;

      .btn {
        width: 170px;
        height: 52px;
        border-radius: 26px;
        border: 2px solid #fff;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:first-child {
          margin-right: 16px;
          background: linear-gradient(139deg, #0884ff 0%, #a3d5ff 100%);
        }

        &:last-child {
          background: linear-gradient(151deg, #ff2932 0%, #ff9900 100%);
        }

        &:active {
          opacity: 0.75;
        }
      }
    }
  }
}

.PosterDialog {
  background-color: transparent !important;
  box-shadow: none !important;

  .PosterContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .closeBtn {
      position: absolute;
      color: #fff;
      right: -5px;
      top: -30px;
      cursor: pointer;

      i {
        font-size: 24px;
      }
    }

    .poster {
      height: 70vh;
      overflow-y: auto;
      margin-bottom: 20px;
    }

    .downBtn {
      background-color: #fff;
      color: #080808;
      width: 260px;
      height: 40px;
      border-radius: 20px;
      text-align: center;
      font-size: 16px;
      line-height: 40px;
      cursor: pointer;
    }
  }
}

.DescDialog {
  .el-dialog__body {
    padding-top: 0;

    p {
      line-height: 20px;

      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }
}
</style>
